import $ from 'jquery';
import _ from 'underscore';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { clientSideDownload } from '@bingads-webui-campaign/auction-insight-common';
import { segmentationType, adinsightSegmentationTypeEnum } from '@bingads-webui-campaign/segmentation-utilities';
import {
  CAMPAIGN_TYPES,
} from '@bingads-webui-campaign/competition-auction-insight-preferences';
import { setSegmentationData } from '@bingads-webui-campaign-react/competition-core';

import { getColumnChooserConfig } from './general-insights-grid-columns';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/competition-tab');
const DownloadView = globalContext.require('campaignui/feature/griddownload/view/baseDownload');
const appConfig = globalContext.require('component/config/index');
const appState = globalContext.require('component/state/index');
const permissions = appConfig.get('Permissions');
const { getSegType, setSegType } = globalContext.require('component/bingads-grid/service/segmentation-preferences');
const instrumentation = globalContext.require('campaignui/feature/instrumentation/index');
const preferencesService = globalContext.requireDefault('component/preference/service/index');

const campaignTypeItems = _.map(_.values(CAMPAIGN_TYPES), (campaignType, index) => ({
  id: index,
  text: i18n.getString(`AuctionInsights_CampaignType_${campaignType}`),
  key: campaignType,
}));

export function getPluginsConfig({
  scope,
  addDateChangeListener,
  container,
  toggleChartToolbar,
  view,
  campaignType,
  onCampaignTypeSelectChange,
  showCampaignTypeDropdown,
  showAlertHandler,
}) {
  const upperToolbarItems = [{
    type: 'button',
    id: 'button-chart-toggle',
  }, {
    type: 'pill-control',
    id: 'summary-overtime',
  }, {
    type: 'dropdown',
    id: 'filter-menu',
  }, {
    type: 'dropdown',
    id: 'dropdown-segment',
  }];

  if (showCampaignTypeDropdown) {
    upperToolbarItems.push({
      type: 'selector',
      id: 'dropdown-campaign-type',
      items: campaignTypeItems,
      selectedKey: campaignType,
      onChange({ key }) {
        if (key !== campaignType) {
          onCampaignTypeSelectChange({
            campaignType: key,
          });
        }
      },
    });
  }

  const lowerToolbarItems = [{
    type: 'button',
    id: 'button-download',
  }, {
    type: 'dropdown',
    id: 'dropdown-column-chooser',
  }];

  const segmentationTypesForSummaryMenu = [
    segmentationType.DayOfWeek,
    segmentationType.HourOfDay,
    segmentationType.Device,
  ];
  const segmentationTypesForOverTimeMenu = [
    segmentationType.Day,
    segmentationType.Week,
    segmentationType.Month,
    segmentationType.Quarter,
    segmentationType.Year,
    segmentationType.Device,
  ];

  return {
    dateFilter: {
      state: appState,
      addDateChangeListener,
    },
    toolbar: {
      'upper-toolbar': {
        items: upperToolbarItems,
      },
      'lower-toolbar': {
        items: lowerToolbarItems,
      },
    },
    columnChooser: getColumnChooserConfig({ campaignType }),
    inlineDownload: {
      DownloadView,
      isAvailable: true,
      i18n,
      entity: 'AuctionInsight',
      customDownloadService: (format, segmentType) => {
        clientSideDownload(format, segmentType, view, scope, appState, i18n, showAlertHandler);
      },
      downloadFormats: ['Csv'],
      segmentationTypes: adinsightSegmentationTypeEnum,
    },
    placeholder: {
      container: '.general-insights .grid-noresult',
      filteredEmptyText: i18n.getString('Grid_NoFilteredRecords'),
      text: i18n.getString('AuctionInsights_GridNoDataDetail'),
    },
    uiBlocker: {
      el: container && $(container),
    },
    segment: {
      cellTemplates: {
        DisplayDomain: 'default',
      },
      i18n,
      permissions,
      cultureShortDatePattern: 'M/d/yyyy',
      state: appState,
      setSegType(name, segType) {
        setSegmentationData({
          gridName: name,
          segType,
          setSegType,
          preferencesService,
        });
      },
      isOdataActionSource: false,
      edm: null,
      segmentationTypes: [], // use pill control to dynamic set allowed segmentation types
      instrumentation,
      getSegType,
    },
    pillControl: {
      i18n,
      segmentationTypesCollection: [
        segmentationTypesForOverTimeMenu,
        segmentationTypesForSummaryMenu,
      ],
    },
    chart: {
      toggleChartToolbar,
    },
    performanceLogNew: {
      instrumentation: instrumentation.default,
    },
  };
}
